/* global integrationConfigured, syncEnabled, action, toggleErpUrl, model, syncNowUrl, fetchUsersUrl, suppliersIndexUrl */
/* global suppliersCreateUrl, suppliersUpdateUrl, suppliersDeleteUrl, exportSuppliersToFile, supplierContractTermsIndexUrl */
/* global supplierContractsIndexUrl, supplierContractDeleteUrl, supplierContractBulkDeleteUrl, supplierContractTermStoreUrl, supplierContractTermUpdateUrl, supplierContractTermDeleteUrl */
/* global downloadSupplierContractsTermAttachmentUrl, deleteSupplierContractsTermAttachmentUrl cancelPOUrl displayApprovalStatuses */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SuppliersIndexTable from './SuppliersIndexTable';

import { UsersProvider } from 'Context/UsersContext';

function SuppliersIndex(props) {
    return (
        <SuppliersIndexTable
            fetchUsersUrl={fetchUsersUrl}
            suppliersIndexUrl={suppliersIndexUrl}
            suppliersCreateUrl={suppliersCreateUrl}
            suppliersUpdateUrl={suppliersUpdateUrl}
            suppliersDeleteUrl={suppliersDeleteUrl}
            exportToFile={exportSuppliersToFile}
            supplierContractTermsIndexUrl={supplierContractTermsIndexUrl}
            supplierContractsIndexUrl={supplierContractsIndexUrl}
            supplierContractDeleteUrl={supplierContractDeleteUrl}
            supplierContractBulkDeleteUrl={supplierContractBulkDeleteUrl}
            supplierContractTermStoreUrl={supplierContractTermStoreUrl}
            supplierContractTermUpdateUrl={supplierContractTermUpdateUrl}
            supplierContractTermDeleteUrl={supplierContractTermDeleteUrl}
            downloadSupplierContractsTermAttachmentUrl={downloadSupplierContractsTermAttachmentUrl}
            deleteSupplierContractsTermAttachmentUrl={deleteSupplierContractsTermAttachmentUrl}
            integrationConfigured={props.integrationConfigured}
            syncEnabled={props.syncEnabled}
            action={props.action}
            toggleUrl={props.toggleUrl}
            model={props.model}
            syncNowUrl={props.syncNowUrl}
            cancelPOUrl={cancelPOUrl}
            displayApprovalStatuses={displayApprovalStatuses}
        />
    );
}

export default SuppliersIndex;
if (document.getElementById('SuppliersIndex')) {
    var rootEl = document.getElementById('SuppliersIndex');
    ReactDOM.render(
        <App>
            <UsersProvider fetchUrl={fetchUsersUrl}>
                <SuppliersIndex
                    integrationConfigured={integrationConfigured}
                    syncEnabled={syncEnabled}
                    action={action}
                    toggleUrl={toggleErpUrl}
                    model={model}
                    syncNowUrl={syncNowUrl}
                />
            </UsersProvider>
        </App>,
        rootEl,
    );
}
